const _ = 160, R = 4, O = 2, E = 2, I = 2, A = 24, T = 40, s = 1, N = 4, C = 16, S = 8, D = 464, M = 0.7798, P = 0.7792, a = 8, c = 4;
export {
  A as C,
  C as H,
  D as M,
  P,
  a as R,
  c as S,
  S as a,
  M as b,
  O as c,
  E as d,
  R as e,
  N as f,
  I as g,
  s as h,
  T as i,
  _ as j
};
